<template>
  <v-app id="app">
<!--    <v-overlay :value="loading" :opacity=".95" >-->
<!--      <v-progress-circular-->
<!--              indeterminate-->
<!--              :size="100"-->
<!--              color="white"-->
<!--      ></v-progress-circular>-->
<!--    </v-overlay>-->
    <v-app-bar
      app
      color="grey lighten-5"
      v-if="$route.meta.header !== false"

    >
      <div class="d-flex align-center">
        <v-img
          alt="TEAMTRI Logo"
          class="shrink mr-2"
          contain
          src="./assets/tri-logo-small.png"
          transition="scale-transition"
          width="40"
        />
      </div>
      <h3>Client Portal</h3>

      <v-spacer></v-spacer>

      <v-btn
              text
              to="/"
              class="mr-2"
              active-class="blue lighten-5"
      >
       Dashboard
      </v-btn>
      <v-btn
              text
              to="/request"
              class="mr-2"
              active-class="blue lighten-5"
      >New Request</v-btn>
      <v-btn @click="signOut" text>Sign Out</v-btn>

    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>
    <v-footer
            color="white"
            app
            padless
            absolute
            v-if="$route.meta.footer !== false"
    >
      <v-row
              justify="center"
      >
        <v-col
                class="text-center"
                cols="12"
        >
          <v-img
                  alt="TEAMTRI Logo"
                  contain
                  src="./assets/tri-logo-large.png"
                  transition="scale-transition"
                  height="25"
                  class="mb-2 mt-2"
          />
          <span class="overline">&copy; {{ new Date().getFullYear() }} — TEAMTRI. All rights reserved.</span>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import { Auth, Hub } from 'aws-amplify'

export default {
  name: 'app',
  components: {
  },
  data: () => ({
    loading: true,
  }),
  methods: {
    signOut() {
      Auth.signOut()
              .then(() => console.log("Goodbye!"))
              .catch(err => console.log(err));
    },
  },
  beforeCreate() {
    Hub.listen('auth', data => {
      const { payload } = data;
      if (payload.event === 'signIn') {
        this.$router.push('/');
      }
      if (payload.event === 'signOut') {
        this.$router.push('/auth');
      }
    });
  },
};
</script>
<style>
  body, .v-application {
    background-color: #f5f5f5 !important;
  }
  .v-application--wrap {
    min-height: 0vh !important;
  }
</style>
